import React, { Component } from 'react'
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './FailedPayout.css';
import cx from 'classnames';
import getFailedPayoutList from './getFailedPayoutList.graphql';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import FailedPayoutList from '../../../components/SiteAdmin/FailedPayout/FailedPayoutList';
import Loader from '../../../components/Common/Loader/Loader';

export class FailedPayout extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired
    }

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { title, getFailedPayoutData, getFailedPayoutData: { loading } } = this.props;

        return (
            <Loader type={"page"} show={loading}>
            <div className={s.root}>
                <div className={s.container}>
                   <div className={cx(s.heading, 'textAlignRightRTL')}>
                        {title}
                    </div>
                    <div className={s.paddingRoutesSection}>
                        <FailedPayout getFailedPayoutData={getFailedPayoutData} />
                    </div>
                </div>
            </div>
            </Loader>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(getFailedPayoutList, {
        name: 'getFailedPayoutData',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only'
        }
    })
)(FailedPayoutList);
